import React from "react"
import { Box } from "@mui/material"
import makeStyles from "@mui/styles/makeStyles"
import CloseIcon from "@mui/icons-material/Close"

const useStyles = makeStyles(() => ({
  insideIcon: {
    borderRadius: "50%",
    width: 20,
    height: 20,
  },
  withMargin: {
    marginTop: -3,
  },
}))

function IconClose({ color = "white", bgColor = "red", withMargin = false }) {
  const classes = useStyles()

  return (
    <Box display="flex" alignItems="center">
      <CloseIcon
        className={`${classes.insideIcon} ${withMargin ? classes.withMargin : ""}`}
        style={{ backgroundColor: bgColor, color }}
      />
    </Box>
  )
}

export default IconClose